import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/app");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#09090b] grid place-items-center px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 mb-6 justify-center">
          <div className="w-6 h-6 rounded-sm bg-zinc-100 text-zinc-950 grid place-items-center">
            <Sparkles size={13} />
          </div>
          <span className="font-heading font-bold tracking-tight">MarketTrace</span>
        </Link>
        <div className="border border-zinc-800 rounded-md p-6 bg-[#0b0b0f]">
          <h1 className="font-heading text-xl font-bold text-zinc-100">Sign in</h1>
          <p className="text-xs text-zinc-500 mt-1">Continue to your intelligence dashboard.</p>
          <form onSubmit={submit} className="mt-5 space-y-3" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-xs">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="input-email"
                className="mt-1 bg-zinc-900 border-zinc-800"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="input-password"
                className="mt-1 bg-zinc-900 border-zinc-800"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-xs text-rose-400 border border-rose-500/25 bg-rose-500/10 rounded-sm px-2 py-1.5">
                {error}
              </div>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="btn-submit-login"
              className="w-full bg-zinc-100 text-zinc-950 hover:bg-white"
            >
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
          <div className="mt-4 text-xs text-zinc-500 text-center">
            No account?{" "}
            <Link to="/register" className="text-zinc-200 hover:underline" data-testid="link-to-register">
              Create one
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
